import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import usePopUp from 'src/hook/modal/usePopUp';
import useUser from '../../../../../hook/data/useUser';
import { CardBackgroundOption } from '../../../../../model/enum/enums';
import { Word } from '../../../../../model/Word';
import { SenseImageLocation, SenseVideoLocation } from '../../../../../utils/URLUtils';
import styles from './VideoSection.module.scss';

interface VideoSectionProps {
    word: Word;
    checkPro?: boolean;
    showVideo?: boolean;
}

const VideoSection: FC<VideoSectionProps> = ({ word, showVideo = true }) => {
    const [videoError, setVideoError] = useState(false);
    const { userInfo, isProUser } = useUser();
    const { showProPopUp } = usePopUp();
    const allowImage = isProUser() || (userInfo?.DateAdded && new Date(userInfo.DateAdded).toDateString() === new Date().toDateString());
    const { t } = useTranslation();

    if (isProUser() && showVideo && !videoError && userInfo?.CardBackground === CardBackgroundOption.VideoOrImage) {
        return (
            <div className={styles.imageContainer}>
                <video
                    className={styles.coverImage}
                    autoPlay
                    // controls
                    playsInline
                    onError={() => setVideoError(true)}
                    src={SenseVideoLocation(word?.PrimarySenseId)}
                />
            </div>
        );
    }

    return (
        <div className={styles.imageContainer}>
            <img
                className={styles.coverImage}
                src={SenseImageLocation(word?.PrimarySenseId, !allowImage)}
                alt={word?.Text}
            />
            {!allowImage && (
                <span
                    className={styles.showImageButton}
                    onClick={() => showProPopUp('Word photos & videos',
                        'Over 500,000 clips to bring every word to life, because your memory is visual.')}
                >
                    {t('Show Image')}
                </span>
            )}
        </div>
    );
};

export default VideoSection;